export default "__VITE_ASSET__BerCi1Qu__"